// ==============================|| OVERRIDES - AUTOCOMPLETE ||============================== //

export default function Autocomplete(theme) {
	return {
		MuiAutocomplete: {
			styleOverrides: {
				root: {
					'& .MuiFilledInput-root': {
						minHeight: '63px',
						padding: '14px 24px 10px 16px',
					}
				},
			}
		}
	};
}
